import { GoogleAnalytics } from "./GoogleAnalytics"

const GTM_ID = "GTM-PZKT822M"

export type AnalyticsService = "google" | "gtm"

const DEFAULT_SERVICES: AnalyticsService[] = ["google"]

function GoogleTagManager({ gtmId = GTM_ID }: { gtmId?: string }) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`,
      }}
    />
  )
}

export function Analytics({
  services,
}: {
  services?: AnalyticsService[]
} = {}) {
  const enabled = services === undefined ? DEFAULT_SERVICES : services
  if (enabled.length === 0) {
    return null
  }

  return (
    <>
      {enabled.includes("google") && <GoogleAnalytics />}
      {enabled.includes("gtm") && <GoogleTagManager />}
    </>
  )
}
